import { render, staticRenderFns } from "./QuaffBlueContainer.vue?vue&type=template&id=db93146e&scoped=true"
import script from "./QuaffBlueContainer.vue?vue&type=script&lang=js"
export * from "./QuaffBlueContainer.vue?vue&type=script&lang=js"
import style0 from "./QuaffBlueContainer.vue?vue&type=style&index=0&id=db93146e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db93146e",
  null
  
)

export default component.exports